<script lang='ts' setup>
import { computed, CSSProperties } from 'vue';

// #region defineProps
const props = defineProps({
  /**Ширина */
  width: { type: String, default: "0rem"},
  /**Высота */
  height: {type: String, default: "0rem"},
  /**Скругление углов */
  borderRadius: {type: String, default: "0rem"},
});
// #endregion defineProps

// #region computed
const style = computed<CSSProperties>(() => ({
  width: props.width,
  height: props.height,
  borderRadius: props.borderRadius
}))
// #endregion computed
</script>

<template>
  <div class="tir-pm-skeleton-loader" :style="style" />
</template>

<style lang='scss' scoped>
.tir-pm-skeleton-loader {
  animation: shimmer var(--tir-pm-skeleton-loader__animation-duration, 1.5s) infinite linear;
    background: linear-gradient(
      90deg,
      var(--tir-pm-skeleton-loader__color, #eaeaeb) 25%,
      var(--tir-pm-skeleton-loader__shimmer-color, #d4d5d7) 50%,
      var(--tir-pm-skeleton-loader__color, #eaeaeb) 75%
    );
    background-size: 200% 100%;

  @keyframes shimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }
}
</style>